import { FaArrowsAlt, FaBan, FaCog, FaPlus, FaSave } from "react-icons/fa";
import { useSelector } from "react-redux";
import { disableEditableDashboard, openPIN, enableDraggableDashboard, disableDraggableDashboard } from "../store/config.dispatch";

import './Settings.scss';
import { openAddCard } from "../store/cards.dispatch";
export const Settings = () => {
  const editableDashboard = useSelector(state => state.config.editableDashboard);
  const draggableDashboard = useSelector(state => state.config.draggableDashboard);

  const saveHandler = () => {
    if (editableDashboard) {
      disableEditableDashboard();
      delete localStorage.cancelLayout;
      localStorage['grid-layout'] = localStorage['temp-grid-layout'];
    } else {
      openPIN();
    }
  }

  const cancelChanges = () => {
    if (localStorage.cancelLayout) localStorage['grid-layout'] = localStorage.cancelLayout;
    delete localStorage.cancelLayout;
    disableEditableDashboard();
    disableDraggableDashboard();
  }

  return (
    <div
      className="
        RightCornerOptions
        fixed
        z-10
        bottom-0
        right-0
        mr-5
        mb-5
      "
    >
      {!editableDashboard &&
        <button onClick={openPIN}>
          <FaCog
            className="settings"
          />
        </button>}
      {editableDashboard &&
        <div className="flex flex-row gap-2 cursor-pointer ">
          <FaPlus
            onClick={openAddCard}
          />
          <FaArrowsAlt
            onClick={() => {
              localStorage.cancelLayout = localStorage['grid-layout'];
              if (draggableDashboard) {
                localStorage['grid-layout'] = localStorage['temp-grid-layout'];
                disableDraggableDashboard();
              } else {
                enableDraggableDashboard();
              }
            }}
          />
          <FaSave
            onClick={saveHandler} 
          />
          <FaBan
            onClick={cancelChanges}
          />
        </div>
      }
    </div>
  )
}